// NOTE: サービス全体で共通して使用するアニメーション速度（ms）
export const ANIMATION_TIME = 3000;
